import axios from "axios"

const baseURL = process.env.REACT_APP_API_BASE_URL

export const TOKEN_KEY = "ife_auth_token"

export const urls = {
  getEventDetails: `/events/`,
  loginSendOTP: `/auth/verifyPhone/sendOtp`,
  verifyOTP: `/auth/verifyPhone/compareOtp`,
  emailLogin: `/auth/email/login`,
  emailRegister: `/auth/email/register`,
  googleVerify: `/auth/google/verify`,
  getSubscriptionEventConfig: `/gallery/config?eventId=`,
  getUserByPhoneNumber: `/user/phone/`,
  getAllFilesOfEvents: `/file/list?eventId=`,
  getFoldersOfEvent: `/folder/list?eventId=`,
  listPhysicalAlbums: `/physical-album/list`,
  physicalAlbumFiles: `/physical-album/files`,
  deleteFileFromEvent: `/file/delete/list`,
  move: `/file/move`,
  joinEvent: `/events/join`,
  aiSearch: `/faces/myphotos?eventId=`,
  uploadFiles: `/events/upload/v2`,
  presignUploads: `/uploads/presign`,
  confirmUploads: `/uploads/confirm`,
  createProfile: `/user/createProfile`,
}

const apiClient = axios.create({ baseURL })

// Attach the JWT on every request if one is stored.
apiClient.interceptors.request.use((config) => {
  const token = localStorage.getItem(TOKEN_KEY)
  if (token) {
    config.headers = config.headers ?? {}
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
})

export default apiClient
